import React, { useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useSelector, useDispatch } from 'react-redux';

import { FormControl, MenuItem, Select } from '@mui/material';

import { updatePropertyInfo } from '../../../actions';

import { PROPERTY_TYPE, OCCUPANCY_TYPE } from '../../../constants/Dashboard/Financing/mortgage';

import './MortgageFinancing.css';

export const MortgageFinancing = () => {
  const dispatch = useDispatch();
  const { ALL_OCCUPANCY_TYPES, ALL_PROPERTY_TYPES, occupancyType, propertyType } = useSelector(
    ({
      propertyReducer: { ALL_PROPERTY_TYPES, ALL_OCCUPANCY_TYPES, occupancyType, propertyType },
    }) => ({
      ALL_PROPERTY_TYPES,
      ALL_OCCUPANCY_TYPES,
      occupancyType,
      propertyType,
    }),
  );
  const [propertyTypeState, setPropertyType] = useState(propertyType);
  const [occupancyTypeState, setOccupancyType] = useState(occupancyType);

  return (
    <div className="mortgage-loans-property-occupancy-info-row">
      <div className="mortgage-loans-property-field-wrapper">
        <p className="property-type-occupancy-label">{PROPERTY_TYPE}</p>
        <FormControl
          sx={{
            m: 0,
            width: '100%',
          }}
        >
          <Select
            id="mortgage-financing-select-helper"
            value={propertyTypeState}
            onChange={(e) => {
              setPropertyType(e.target.value);
              dispatch((dispatch) => {
                updatePropertyInfo(dispatch, { propertyType: e.target.value });
              });
              mixpanel.track('Mortgage_Calculator', {
                financingType: 'HOME',
                FINANCE_FIELD: 'PROPERTY TYPE',
                PROPERTY_TYPE: e.target.value,
              });
            }}
          >
            {ALL_PROPERTY_TYPES.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="mortgage-loans-occupancy-field-wrapper">
        <p className="property-type-occupancy-label">{OCCUPANCY_TYPE}</p>
        <FormControl
          sx={{
            m: 0,
            width: '100%',
          }}
        >
          <Select
            id="mortgage-financing-select-helper"
            value={occupancyTypeState}
            onChange={(e) => {
              setOccupancyType(e.target.value);
              dispatch((dispatch) => {
                updatePropertyInfo(dispatch, { occupancyType: e.target.value });
              });
              mixpanel.track('Mortgage_Calculator', {
                financingType: 'HOME',
                FINANCE_FIELD: 'OCCUPANCY TYPE',
                OCCUPANCY_TYPE: e.target.value,
              });
            }}
          >
            {ALL_OCCUPANCY_TYPES.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};
